import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import get from 'lodash/get';

import {
  AccountApiAccountUsernameResetPasswordPatchRequest,
  Api,
  useApi,
} from '@sbv-clients/data-access-api';
import { useSnackBar } from '@sbv-clients/ui-shared';

const resetPassword =
  (api: Api) =>
  (
    resetPasswordRequest: AccountApiAccountUsernameResetPasswordPatchRequest
  ) => {
    return api.accountApi.accountUsernameResetPasswordPatch(
      resetPasswordRequest
    );
  };

export const useResetPassword = () => {
  const api = useApi();
  const navigate = useNavigate();
  const { notifyError } = useSnackBar();

  return useMutation(resetPassword(api), {
    onSuccess: () => {
      navigate('/auth/success?action=reset-password');
    },
    onError: async (error) => {
      const message =
        get(error, 'response.data', '') || get(error, 'message', '');
      notifyError(message);
    },
  });
};
